import { render, staticRenderFns } from "./PurchaseActivityLayout.vue?vue&type=template&id=0c01bf21&"
import script from "./PurchaseActivityLayout.vue?vue&type=script&lang=js&"
export * from "./PurchaseActivityLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c01bf21')) {
      api.createRecord('0c01bf21', component.options)
    } else {
      api.reload('0c01bf21', component.options)
    }
    module.hot.accept("./PurchaseActivityLayout.vue?vue&type=template&id=0c01bf21&", function () {
      api.rerender('0c01bf21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/PurchaseActivityLayout.vue"
export default component.exports